export function currentDate(): string {
  return (new Date()).toISOString().substring(0,10);
}
